const data =
  [
    {
      label : "Small",
      description : "Fits in a small backpack or carry-on bag. Less than 2 lbs.",
      id : 1
    },
    {
      label : "Medium",
      description : "Fits in a large duffel bag or carry-on suitcase. 2-5 lbs",
      id : 2
    },
    {
      label : "Large",
      description : "Fits in a large suitcase that requires check-in. 5-20 lbs.",
      id : 3
    },
    {
      label : "Extra Large",
      description : "Needs to be shipped in the cargo area. 20 - 50 lbs. May incur extra fees.",
      id : 4
    }
  ]

  module.exports = {
    data
  }



// WEBPACK FOOTER //
// app/post_a_shipment/post_a_shipment_data.jsx